"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function cov_2mde2gbhkk() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/streamOnline/lib/constants.js";
  var hash = "b8855dd5e01ebe948e848f041330e8a53b838d70";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/streamOnline/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 32
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b8855dd5e01ebe948e848f041330e8a53b838d70"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2mde2gbhkk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2mde2gbhkk();
var StreamOnlineActionTypes = (cov_2mde2gbhkk().s[0]++, {
  STREAM_ONLINE_BEFORE_LOAD: 'STREAM_ONLINE_BEFORE_LOAD',
  STREAM_ONLINE_LOAD_SUCCESS: 'STREAM_ONLINE_LOAD_SUCCESS',
  STREAM_ONLINE_LOAD_ERROR: 'STREAM_ONLINE_LOAD_ERROR',
  STREAM_ONLINE_INITIAL_STATE: 'STREAM_ONLINE_INITIAL_STATE',
  STREAM_ONLINE_UPDATE_DIALOG_VISIBILITY: 'STREAM_ONLINE_UPDATE_DIALOG_VISIBILITY'
});
var _default = exports.default = StreamOnlineActionTypes;